import React from 'react'
import CodeBox from "./CodeBox"

const DocCode = ({ headingText, heading, code, Preview }) => {
    return (
        // {/* x---------------------------------x Documentation Pages Formate Code Section x---------------------------------x */}s
        <div className="w-full">
            <div className="border border-gray-200 rounded-lg sm:p-5 p-1">
                <div className="sm:p-4 p-1 card-body rounded-lg border">
                    <div className="bg-gray-50 border divide-y-2 border-gray-200 sm:p-4 p-2 rounded-lg">
                        <h4 id="discriptionLists" className="text-lg font-semib old sm:px-4 px-2">{heading}</h4>
                        <p className='mt-2 card-body sm:p-4 p-2 rounded-lg text-xs sm:text-base'>{headingText}</p>
                    </div>
                    <div className="bg-gray-50 border divide-y-2 border-gray-200 sm:p-4 p-3 rounded-lg mt-5">
                        <h4 id="discriptionLists" className="text-lg font-semibold sm:px-4 flex items-center gap-2">
                            <svg className="h-5 w-5 flex-none stroke-primary" height="30px" width="30px" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="m13.75 6.75 3.5 3.25-3.5 3.25M6.25 13.25 2.75 10l3.5-3.25"></path></svg>
                            <span>Code</span>
                        </h4>
                    </div>
                    {/* x---------------------------------x Code Box Component x---------------------------------x */}
                    <CodeBox code={code} auto={false} />
                </div>
                <div className='card-body p-1 sm:p-7 sm:px-10 mt-4 rounded-lg border'>
                    <div className="bg-gray-50 border divide-y-2 border-gray-200 sm:p-4 p-3 rounded-lg mb-5">
                        <h4 id="discriptionLists" className="text-lg font-semibold sm:px-4 flex items-center gap-2">
                            <svg className="h-5 w-5 flex-none stroke-primary" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M17.25 10c0 1-1.75 6.25-7.25 6.25S2.75 11 2.75 10 4.5 3.75 10 3.75 17.25 9 17.25 10Z"></path><circle cx="10" cy="10" r="2.25"></circle>
                            </svg>
                            <span>Preview</span>
                        </h4>
                    </div>
                    {/* // x---------------------------------x Code Preview Section x---------------------------------x */}
                    {Preview}
                </div>
            </div>
        </div >
    )
}

export default DocCode